import ListingBadge, { BADGE_ORDER_PRIORITY } from './base'

export default class HotBadge extends ListingBadge {
  static titleV2 = 'Hot'
  static renderPriorityV2 = () => BADGE_ORDER_PRIORITY.SECOND
  static shouldBeIncludedV2 = listing => listing.is_hot
}
